import type EntryPoint from '../store/schema/EntryPoint';
import getLinkWithEntryPoint from '../utils/getLinkWithEntryPoint';
import { getBookWithMePublishedUrl } from 'bookwithme-shared';

/**
 * Util to get published URL of the booking page from store.
 */
export default function getPublishedUrl(entryPoint?: EntryPoint): string {
    let newUrlLink = getBookWithMePublishedUrl();

    if (entryPoint) {
        newUrlLink = getLinkWithEntryPoint(newUrlLink, entryPoint);
    }
    return newUrlLink;
}
